module.exports = __webpack_public_path__ + "img/selected6-min.47d1c6c1.png";